__turbopack_context__.v({
  "container": "FAQ-module__QzEvLG__container",
  "element": "FAQ-module__QzEvLG__element",
});
